function accentColorForOrg({org}) {
  return _.get(org, 'appData.designEngine.accentColor') || '#000000';
}

export { accentColorForOrg };
